import { Component, OnInit } from '@angular/core';

/**
 * [Movemeback ui component library]
 * Alert component
 */
@Component({
  selector: 'mmb-ui-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
